var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{staticClass:"pa-5",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v(_vm._s(_vm.stock.toUpperCase())+" "),_c('span',{attrs:{"id":"performance"}}),_vm._v("Performance - Breakdown by Factors")]),_c('PerformanceBreakdownChart',{attrs:{"id":_vm.stock,"apiEndpoint":'/get-stock-return-breakdown/',"date-key":"date","bar-keys":[
            'Country',
            'Market',
            'Mom',
            'Quality',
            'Residuals',
            'Risk',
            'Sector',
            'Size',
            'Value'
          ],"line-key":"Return"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }